function readMessage(source: unknown): string | null {
  if (typeof source === 'string') return source.trim() || null;
  if (!source || typeof source !== 'object') return null;

  const record = source as Record<string, unknown>;

  if ('value' in record) {
    const nested = readMessage(record.value);

    if (nested) return nested;
  }

  if (Array.isArray(record.errors)) {
    const messages = record.errors.filter((v): v is string => typeof v === 'string');

    if (messages.length > 0) return messages.join('; ');
  }

  return typeof record.message === 'string' ? record.message.trim() || null : null;
}

export function getErrorMessage(error: unknown, fallback: string) {
  return readMessage(error) ?? fallback;
}
